import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { TelsysListFeatureGate } from '../Guards/TelsysListFeatureGate'
import { TelsysList } from '../Components/Organisms/TelsysList/TelsysList'

/**
 * Routed page wrapper for the Telephony Servers list page.
 */
@Route(RouteID.TELSYS)
export class TelsysListPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Telephony Servers page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.TELSYS}>
                <TelsysListFeatureGate>
                    <LanguageContextProvider>
                        <TelsysList />
                    </LanguageContextProvider>
                </TelsysListFeatureGate>
            </RouteGuard>
        )
    }
}
